import { CapturedOrder, Order } from 'app/pages/frames/util/interface';

export const transformCapturedOrderDtoToOrderModel = (capturedOrder: CapturedOrder): Order => ({
  ...capturedOrder,
  charges: [capturedOrder.charge],
});
